/* COMPONENT - C08.03 Lightbox */
'use strict';

export default class Lightbox {
    constructor(element) {
        this.root = element;
        this.triggers = document.querySelectorAll('.js-lightbox-trigger');
        this.closeBtn = this.root.querySelector('.lightbox__close');
        
        this.bindEvents();
    }
    
    toggleLightbox(trigger) {
        event.preventDefault();
        
        if (this.root.classList.contains('lightbox--show')) {
            trigger = document.querySelector('[data-lightbox-triggered]');
            trigger.removeAttribute('data-lightbox-triggered');
            trigger.focus();
            this.root.classList.remove('lightbox--show');
            document.querySelector('html').style.overflowY = "visible";
        } else {
            trigger.setAttribute('data-lightbox-triggered', 'true');
            this.root.classList.add('lightbox--show');
            this.closeBtn.focus();
            document.querySelector('html').style.overflowY = "hidden";
        }
    }

    bindEvents() {
        for (let i = 0; i < this.triggers.length; i++) {
            this.triggers[i].addEventListener('click', this.toggleLightbox.bind(this, this.triggers[i]));
        }
        this.closeBtn.addEventListener('click', this.toggleLightbox.bind(this, this.closeBtn));
    }
}
